import React, { Component } from 'react'
import { Container } from '@sainsburys-tech/fable'
import { AlertCircle } from '@sainsburys-tech/icons'
import LoadingOverlay from '../../LoadingOverlay'
import api from '../../../utils/api'

import PublicDSIBHeader from '../../PublicDSIBHeader'

class EmailVerification extends Component {
  constructor() {
    super()

    this.state = {
      isLoading: false,
      isError: false,
      isSuccess: false,
      tokenExpired: false
    }
  }

  componentDidMount() {
    this.confirmEmail()
  }

  confirmEmail = () => {
    const search = new URLSearchParams(window.location.search)
    const userId = search.get('userId')
    const token = search.get('token')

    this.setState({ isLoading: true })

    api.confirmEmail(userId, token).then((res) => {
      if (res.succeeded) {
        this.setState({
          isLoading: false, isSuccess: true, isError: false, tokenExpired: false
        })
      } else if (res.errors && res.errors[0].code === 'InvalidToken') {
        this.setState({
          isLoading: false, isSuccess: false, isError: false, tokenExpired: true
        })
      } else {
        this.setState({
          isLoading: false, isSuccess: false, isError: true, tokenExpired: false
        })
      }
    }).catch(() => {
      this.setState({
        isLoading: false, isSuccess: false, isError: true, tokenExpired: false
      })
    })
  }

  loginRedirect = () => {
    window.location.href = `${window.location.origin}/login`
  }

  render() {
    const {
      isLoading, isError, isSuccess, tokenExpired
    } = this.state
    let error = false

    if (isError || tokenExpired) {
      error = true
    }

    return (
      <Container size="sm" as="div" className="dsib-emailVerification">
        <PublicDSIBHeader />

        <main className="dsib-emailVerification__content">
          {error && (
            <section className="dsib-emailVerification__panel" aria-live="polite">
              <div className="dsib-emailVerification__statusRow" role="alert">
                <AlertCircle className="dsib-emailVerification__statusIcon" aria-hidden="true" focusable="false" />
                <div className="dsib-emailVerification__statusTitle">
                  {isError
                    ? 'Sorry, there\'s been a problem verifying your email address'
                    : 'Email link has expired'}
                </div>
              </div>

              {tokenExpired && (
                <p className="dsib-emailVerification__helpText">
                  Try and log in to the Sign In Book app and we'll send you another link to validate your email address.
                </p>
              )}

              {isError && (
                <button
                  type="button"
                  className="dsib-emailVerification__link"
                  onClick={() => this.confirmEmail()}
                >
                  Try to verify again
                </button>
              )}
            </section>
          )}

          {isSuccess && (
            <section className="dsib-emailVerification__panel" aria-live="polite">
              <h2 className="dsib-emailVerification__successTitle">Thank you - your email has been verified</h2>
              <p className="dsib-emailVerification__helpText">You can now log into the app</p>
              <p className="dsib-emailVerification__helpText">
                Click
                {' '}
                <button type="button" className="dsib-emailVerification__inlineLink" onClick={this.loginRedirect}>
                  here
                </button>
                {' '}
                to access the Log in page
              </p>
            </section>
          )}
        </main>

        {isLoading && <LoadingOverlay hasBackground text="Confirming your email..." />}
      </Container>
    )
  }
}

export default EmailVerification
